<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h3>{{ phase }} Phase</h3>
      </div>
      <div class="card-body">
        <validation-observer ref="simpleRules">
          <b-form>
            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label for="startDate">Start Date</label>
                  <validation-provider
                    #default="{ errors }"
                    name="startDate"
                    rules="required"
                  >
                    <template>
                      <b-form-datepicker
                        id="startDate"
                        v-model="phaseOne.startDate"
                        :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                        menu-class="w-100"
                        calendar-width="100%"
                      />
                    </template>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="startDate">End Date</label>
                  <validation-provider
                    #default="{ errors }"
                    name="endDate"
                    rules="required"
                  >
                    <template>
                      <b-form-datepicker
                        id="endDate"
                        v-model="phaseOne.endDate"
                        :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                        menu-class="w-100"
                        calendar-width="100%"
                      />
                    </template>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="designType">Design Type</label>
                  <validation-provider
                    id="designType"
                    #default="{ errors }"
                    rules="required"
                  >
                    <v-select
                      v-model="phaseOne.designTypes"
                      name="designType"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="designTypes"
                      :reduce="name => name.id"
                      label="name"
                      multiple
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label for="type">Site Visit Form</label>
                  <a
                    v-if="parentObj && parentObj.siteVisitForm"
                    :href="parentObj && parentObj.siteVisitForm && parentObj.siteVisitForm.url"
                    target="_blank"
                  ><small style=" float: right;">View Old File?</small></a>
                  <validation-provider
                    #default="{ errors }"
                    name="siteVisitForm"
                    :rules="customRules"
                  >
                    <b-form-file
                      v-model="phaseOne.siteVisitForm"
                      :file-name-formatter="formatNames"
                      accept=".pdf"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label for="completionForm">Completion Form</label>
                  <a
                    v-if="parentObj && parentObj.completionForm"
                    :href="parentObj && parentObj.completionForm && parentObj.completionForm.url "
                    target="_blank"
                  ><small style=" float: right;">View Old File?</small></a>
                  <validation-provider
                    #default="{ errors }"
                    name="completionForm"
                    :rules="customRules"
                  >
                    <b-form-file
                      v-model="phaseOne.completionForm"
                      :file-name-formatter="formatNames"
                      accept=".pdf"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                md="12"
                style="display: flex; justify-content: end;"
              >
                <button
                    id="submit-phase"
                  type="button"
                  class="btn btn-outline-primary mt-2"
                  @click.prevent="validationForm"
                >
                  <feather-icon
                    icon=""
                    class="mr-25"
                  />
                  Submit
                </button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'

import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BFormDatepicker, BFormFile,
} from 'bootstrap-vue'
import {
  required, email, confirmed, password,
} from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import { codeBasic } from './code'
import PhaseOneService from '@/services/project/phaseOneService'
import designTypesService from '@/services/settings/designTypesService'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect,
    BFormFile,
    BFormDatepicker,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
  },
  props: ['phase', 'parentObj'],
  data() {
    return {
      customRules: 'required',
      url: '',
      designTypes: [],
      loading: false,
      phaseOne: {
        designTypes: [],
        startDate: '',
        endDate: '',
        completionForm: null,
        siteVisitForm: null,
      },
      required,
      password,
      email,
      confirmed,
    }
  },
  mounted() {
    this.getdesignTypesService()
    this.$watch(() => this.tab, val => {
      this.choosenTab = val
    })
    this.$watch(() => this.parentObj, parentObj => {
      if (parentObj !== null) {
        console.log('parentObj', parentObj)
        this.phaseOne = {
          designTypes: [],
          startDate: parentObj.startDate,
          endDate: parentObj.endDate,
          completionForm: null,
          siteVisitForm: null,
        }
        this.customRules = ''
        for (let i = 0; i < parentObj.designTypes.length; i++) {
          this.phaseOne.designTypes.push(parentObj.designTypes[i].id)
        }
      }
    })

  },
  methods: {
    getdesignTypesService() {
      this.loading = true
      designTypesService.index()
        .then(response => {
          this.loading = false
          this.designTypes = response.data.data
        })
    },
    formatNames(files) {
      if (files.length === 1) {
        return files[0].name
      }
      return `${files.length} files selected`
    },
    validationForm() {
      document.getElementById('submit-phase').setAttribute('disabled', 'disabled')

      this.loading = true
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          console.log('phaseOne', this.phaseOne)
          PhaseOneService.post(this.$route.params.id, this.phaseOne)
            .then(response => {
              if (response && response.status === 200) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Success',
                    icon: 'CheckIcon',
                    variant: 'success',
                    text: 'Phase One Is Updated Successfully !',
                  },
                })
                setTimeout(function(){
                  document.getElementById('submit-phase').removeAttribute('disabled')
                }, 5000);


              }
              this.$emit('refreshPanel', 'true')
              this.loading = false
            })
        }
        else{
          document.getElementById('submit-phase').removeAttribute('disabled')

        }
      }).catch(error => {
        Promise.reject(error)
        setTimeout(function(){
          document.getElementById('submit-phase').removeAttribute('disabled')
        }, 5000);
      })

    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
<style>
#designType svg{
  filter: invert(69%) sepia(14%) saturate(4763%) hue-rotate(3deg) brightness(100%) contrast(43%)!important;
}
</style>
